import React from 'react'
import { useTranslation } from 'react-i18next';
import BoxFormControlsPortal from '../RightSide/BoxFormControlsPortal'
import BoxCopyDeleteButtons from './BoxCopyDeleteButtons'
import BoxAlignmentButton from './BoxAlignmentButton'
import BoxGroupButton from './BoxGroupButton'

// Aligner/dupliquer/supprimer la box sélectionnée : plus de barre flottante
// sur le canvas pour une box seule (gardée uniquement pour la sélection de
// texte en surbrillance et pour un container sélectionné), ces actions
// vivent dans le panel de droite comme le reste des contrôles de la box.
const BoxActionsPanel = () => {
  const { t } = useTranslation();

  return (
    <BoxFormControlsPortal title={t('box-actions')} layout="row" order={-1} keepOnMultiSelection>
      <BoxAlignmentButton showLabel />
      {/* Tuile montrée seulement en multi-sélection (ou sur un groupe, pour le
          dégrouper) : elle s'ajoute aux actions au lieu d'un bouton isolé en
          haut à droite de l'écran. */}
      <BoxGroupButton showLabel />
      <BoxCopyDeleteButtons withLabels />
    </BoxFormControlsPortal>
  )
}

export default BoxActionsPanel
